import {RouterPaths} from "../routerPaths";
import {importPages} from "../lazyRoute";

const languageRoutes = [
    {
        path: RouterPaths.LANGUAGES,
        element: importPages.Languages,
    },
    {
        path: RouterPaths.TRANSLATIONS,
        element: importPages.Translations,
    },

]
export  default languageRoutes